/**
 * 询价列表切换时的 loading 遮层(目的是为了解决点击某个计价和报价后，用户感知不到左侧内容区域的变化)
 * @module LoadingLayer
 * @see 文档: http://i.shijiebang.net/wiki/pages/viewpage.action?pageId=12394536 其中第四个需求
 * @author ianva
 */

var Modal = require('react-modal');
var React = require("react");
var _ = require("underscore");

/**
 * 显示数据刷新成功失败状态的时间
 */
var LOADED_DURATION = 500;

var customStyles = {
    content : {
        border                : 'none',
        padding               : 0,
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)'
    }
};

/**
 * 加载中
 */
function LoadingContent() {
    return (
        <div className="loading-content">
            <img src="//f4.jiejiatech.net/y16/0801/2119/00fai_o.gif" className="loading-pic"/>
            行程及商品数据刷新中...
        </div>
    )
}
/**
 * 加载成功
 */
function SuccessContent() {
    return (
        <div className="success-content">
            <i className="icon-a-success"></i>
            数据刷新完成
        </div>
    )
}

var LoadingLayer = React.createClass({

    getDefaultProps(){
        return {
            duration: 2000
        }
    },
    getInitialState(){

        return {
            isOpen: this.props.isOpen,
            isLoaded: false
        }
    },
    componentWillReceiveProps(nextProps){

        this.setState({
            isOpen: nextProps.isOpen,
        });

        this.setLoadState();
        
    },
    /**
     * 设置 loading 时的状态切换（加载中 => 成功）
     */
    setLoadState(){

        var duration = this.props.duration
        var self = this;

        setTimeout(()=>{

            // 切换遮层 load 状态
            self.setState({
                isLoaded: true
            });

            setTimeout(()=>{

                // 关闭遮层
                self.setState({
                    isOpen: false
                });

                self.setState({
                    isLoaded: false
                })

            },LOADED_DURATION);

        },  duration - LOADED_DURATION);

    },
    render(){

        return (
            <Modal overlayClassName="mod-loading-layer" isOpen={this.state.isOpen} style={customStyles} onRequestClose={ this.props.onRequestClose }>
                {
                    this.state.isLoaded
                        ? <SuccessContent></SuccessContent>
                        : <LoadingContent></LoadingContent>
                }
            </Modal>
        )
    }

});

module.exports = LoadingLayer





/** WEBPACK FOOTER **
 ** ./script/cutil/LoadingLayer.jsx
 **/